import {
  breakpointSizes,
  getBreakpointDown,
  getBreakpointOnly,
  getBreakpointUp,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { useMemo } from 'react'
import NavAwayBox from 'src/components/NavAwayBox/NavAwayBox'
import Trns from 'src/localization/Trns'
import { NotificationSettingListModel } from 'src/models/notificationSetting.models'
import { profileNotificationsUrl } from 'src/navigation/urls'
import { css } from 'styled-components'

interface NotificationsSummaryBoxProps {
  className?: string
  notificationSettings: NotificationSettingListModel[]
}

const NotificationsSummaryBox: React.FC<NotificationsSummaryBoxProps> = (
  props,
): React.ReactElement => {
  const enabledNotificationSettings = useMemo(
    () => props.notificationSettings.filter((sett) => sett.enabled),
    [],
  )

  return (
    <NavAwayBox
      className={props.className}
      navAway={{
        to: profileNotificationsUrl(),
        label: <Trns source={'Notification Settings'} />,
        ariaLabelSource: 'Notification Settings',
      }}
    >
      <div
        css={css`
          display: flex;
          align-items: flex-end;
          padding: ${styleConstants.heights.cardPadding}
            ${styleConstants.widths.cardPaddingXSMUp};

          ${getBreakpointOnly(breakpointSizes.XXSM)(css`
            padding: ${styleConstants.heights.cardPadding}
              ${styleConstants.widths.cardPaddingXXSMOnly};
          `)}
        `}
      >
        <span
          css={css`
            ${getFontCss(
              20,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )};
          `}
        >
          <Trns source={'Notifications'} />
        </span>
        <span
          css={css`
            margin-left: 20px;
            ${getFontCss(
              20,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};

            ${enabledNotificationSettings.length ===
              props.notificationSettings.length &&
            css`
              ${getFontCss(
                20,
                themeConstants.colors.highlight,
                styleConstants.fontFamilies.regular,
              )};
            `}

            ${getBreakpointDown(breakpointSizes.XSM)(css`
              display: none;
            `)}
          `}
        >
          {enabledNotificationSettings.length ===
            props.notificationSettings.length &&
            enabledNotificationSettings.length > 0 && (
              <Trns source={'All Notifications Enabled'} />
            )}
          {enabledNotificationSettings.length <
            props.notificationSettings.length &&
            enabledNotificationSettings.length > 0 && (
              <Trns source={'Some Notifications Disabled'} />
            )}
          {enabledNotificationSettings.length === 0 && (
            <Trns source={'All Notifications Disabled'} />
          )}
        </span>
        <span
          css={css`
            margin-left: 10px;
            ${getFontCss(
              16,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};

            ${enabledNotificationSettings.length ===
              props.notificationSettings.length &&
            css`
              ${getFontCss(
                16,
                themeConstants.colors.highlight,
                styleConstants.fontFamilies.regular,
              )};
            `}

            ${getBreakpointUp(breakpointSizes.SM)(css`
              display: none;
            `)}
          `}
        >
          {enabledNotificationSettings.length ===
            props.notificationSettings.length &&
            enabledNotificationSettings.length > 0 && (
              <Trns source={'All Enabled'} />
            )}
          {enabledNotificationSettings.length <
            props.notificationSettings.length &&
            enabledNotificationSettings.length > 0 && (
              <Trns source={'Some Disabled'} />
            )}
          {enabledNotificationSettings.length === 0 && (
            <Trns source={'All Disabled'} />
          )}
        </span>
      </div>
    </NavAwayBox>
  )
}

export default NotificationsSummaryBox
